import { CTAButton } from "../components/common/CTAButton";

export function ContactPage() {
  return (
    <div className="bg-slate-950 py-24">
      <div className="mx-auto max-w-4xl px-6">
        <header className="text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-emerald-300">
            Contact
          </p>
          <h1 className="mt-4 text-4xl font-semibold text-white">
            If your mission-critical workflow isn’t performing, let’s talk.
          </h1>
          <p className="mt-4 text-slate-300">
            Choose the engagement model that fits. We’ll follow up within 2 business days with a diagnostic snapshot or proposal outline.
          </p>
        </header>
        <form className="mt-16 space-y-6">
          <div className="grid gap-6 sm:grid-cols-2">
            <label className="flex flex-col gap-2 text-sm text-slate-200">
              Name
              <input
                type="text"
                name="name"
                className="rounded-2xl border border-white/10 bg-slate-900 px-4 py-3 text-white focus:border-emerald-400 focus:outline-none"
                placeholder="Your name"
              />
            </label>
            <label className="flex flex-col gap-2 text-sm text-slate-200">
              Organization
              <input
                type="text"
                name="organization"
                className="rounded-2xl border border-white/10 bg-slate-900 px-4 py-3 text-white focus:border-emerald-400 focus:outline-none"
                placeholder="Where you work"
              />
            </label>
          </div>
          <label className="flex flex-col gap-2 text-sm text-slate-200">
            Sector
            <input
              type="text"
              name="sector"
              className="rounded-2xl border border-white/10 bg-slate-900 px-4 py-3 text-white focus:border-emerald-400 focus:outline-none"
              placeholder="Government, healthcare, etc."
            />
          </label>
          <div className="grid gap-6 sm:grid-cols-2">
            <label className="flex flex-col gap-2 text-sm text-slate-200">
              Role
              <input
                type="text"
                name="role"
                className="rounded-2xl border border-white/10 bg-slate-900 px-4 py-3 text-white focus:border-emerald-400 focus:outline-none"
                placeholder="Director, product lead, etc."
              />
            </label>
            <label className="flex flex-col gap-2 text-sm text-slate-200">
              Timeline
              <input
                type="text"
                name="timeline"
                className="rounded-2xl border border-white/10 bg-slate-900 px-4 py-3 text-white focus:border-emerald-400 focus:outline-none"
                placeholder="e.g., Q1 kickoff"
              />
            </label>
          </div>
          <label className="flex flex-col gap-2 text-sm text-slate-200">
            Problem Summary
            <textarea
              name="problem"
              rows={4}
              className="rounded-2xl border border-white/10 bg-slate-900 px-4 py-3 text-white focus:border-emerald-400 focus:outline-none"
              placeholder="What isn’t working today?"
            />
          </label>
          <label className="flex flex-col gap-2 text-sm text-slate-200">
            Budget Range (optional)
            <input
              type="text"
              name="budget"
              className="rounded-2xl border border-white/10 bg-slate-900 px-4 py-3 text-white focus:border-emerald-400 focus:outline-none"
              placeholder="Optional"
            />
          </label>
          <div className="grid gap-4 sm:grid-cols-3">
            <button
              type="button"
              className="rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-sm font-medium text-white hover:border-emerald-300/40 hover:text-emerald-200"
            >
              Strategy Session
            </button>
            <button
              type="button"
              className="rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-sm font-medium text-white hover:border-emerald-300/40 hover:text-emerald-200"
            >
              Diagnostic Audit
            </button>
            <button
              type="button"
              className="rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-sm font-medium text-white hover:border-emerald-300/40 hover:text-emerald-200"
            >
              Full Project Inquiry
            </button>
          </div>
          <CTAButton href="/contact" className="w-full justify-center sm:w-auto">
            Submit inquiry
          </CTAButton>
          <p className="text-xs text-slate-400">
            Expect a follow-up within 2 business days outlining next steps.
          </p>
        </form>
      </div>
    </div>
  );
}
